import { FtuByVenueTableSortBy } from 'apis/merchant-gateway/insights';

import { FtuByVenueTableColumnIDs, FtuByVenueTableSortableColumnIDs } from './types';

export const transformTableSortToApiSortBy = (
  sortBy: FtuByVenueTableSortableColumnIDs | undefined,
  isVATEnabled: boolean,
): FtuByVenueTableSortBy | undefined => {
  switch (sortBy) {
    case FtuByVenueTableColumnIDs.FIRST_TIME_CUSTOMERS_COUNT:
      return 'FIRST_TIME_CUSTOMERS_COUNT';
    case FtuByVenueTableColumnIDs.RETURNING_CUSTOMERS_COUNT:
      return 'RETURNING_CUSTOMERS_COUNT';
    case FtuByVenueTableColumnIDs.FIRST_TIME_AVG_BASKET_ITEMS:
      return 'FIRST_TIME_AVG_BASKET_SIZE_ITEMS';
    case FtuByVenueTableColumnIDs.RETURNING_AVG_BASKET_ITEMS:
      return 'RETURNING_AVG_BASKET_SIZE_ITEMS';
    case FtuByVenueTableColumnIDs.FIRST_TIME_AVG_BASKET_SIZE:
      return isVATEnabled ? 'FIRST_TIME_AVG_BASKET_SIZE_WITH_VAT' : 'FIRST_TIME_AVG_BASKET_SIZE_NO_VAT';
    case FtuByVenueTableColumnIDs.RETURNING_AVG_BASKET_SIZE:
      return isVATEnabled ? 'RETURNING_AVG_BASKET_SIZE_WITH_VAT' : 'RETURNING_AVG_BASKET_SIZE_NO_VAT';
    case undefined:
    default:
      return undefined;
  }
};
